export default __webpack_public_path__ + "static/media/1935.5ad39f1a.png";